import { Communication } from './communication';

export interface LoginResponse {
  latestReleaseNote: Communication;
  viewed: boolean;

  announcements: Communication[];
  tips: Communication[];
}
